module.exports = "<div class=\"app-header-inner\">\n    <ng-transclude></ng-transclude>\n</div>\n";